import { PropsWithChildren } from "react";
import {classNames} from "utils/helpers";
import "./percentage-list.less";

export default function PercentageList(props: PropsWithChildren<{
  className?: string
}>)
{
  return <ul className={classNames("percentage-list", props.className)}>
    {props.children}
  </ul>
}